// import css from "./popUp.module.css";
// import React from "react";

// const PopUpSuport = React.forwardRef(({ onClick }, ref) => {
//   return (
//     <div className={css.suportPopWrap} ref={ref} onClick={onClick}>
//       <p className={css.mainPopP}>
//         Якщо ви працюєте продавцем-консультантом у книгарні, реєструйтеся на
//         сайті як продавець книжок — і отримуйте доступ до конференцій "Скрипти
//         продажу книжок "Часу майстрів", "Ефективний продаж книжок", а також
//         прямих консультацій із керівниками видавництва.
//       </p>
//     </div>
//   );
// });
// export default PopUpSuport;
// src/components/PopUpSuport.jsx
import React from "react";
import css from "./popUp.module.css";
import { db } from "../../firebase"; // скоригуй шлях під свій
import { doc, onSnapshot } from "firebase/firestore";

const DOC_ID = "support_sales_consultants"; // popups/support_sales_consultants

const PopUpSuport = React.forwardRef(({ onClick, className }, ref) => {
  const [html, setHtml] = React.useState("");
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const unsub = onSnapshot(doc(db, "popups", DOC_ID), (snap) => {
      setLoading(false);
      setHtml(snap.exists() ? snap.data()?.contentHtml || "" : "");
    });
    return () => unsub();
  }, []);

  return (
    <div className={`${css.suportPopWrap} `} ref={ref} onClick={onClick}>
      <div
        className={`${css.mainPopP}`}
        dangerouslySetInnerHTML={{ __html: loading ? "…" : html }}
      />
    </div>
  );
});

export default PopUpSuport;
